import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Statistic, Form, Button, Input, Typography, Row, Col, message } from 'antd'
import { Mutations, Queries } from '../../../../graphql'
import { getOrganization } from '../../../../utils/auth'
import { withApollo } from 'react-apollo'
import moment from 'moment'
const { Countdown } = Statistic;

const { Text, Title } = Typography
class OTPFrom extends Component {
    state = {
        // + 1000 * 60 * 60 * 24 * 2 + 1000 * 30
        deadline: (Date.now()),
        otpstate: true,
        called: false,
        tol: null,
        text:'"กรุณากดขอรหัสยืนยันตัวตน" เพื่อรับรหัสยืนยันตัวตนผ่าน SMS',
        valueOTP:null
    }

    onChange = (e) => {
        const { setOTP } = this.props;
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(e.target.value) && reg.test(e.target.value)) || e.target.value === '' || e.target.value === '-') {
            // this.props.onChange(value);
            this.setState({
                valueOTP:e.target.value
            })
            setOTP(e.target.value)
          }
        // this.setState({someVal: e.target.value})
    }

    onChangetel = async (e) => {
        console.log("e.target.value", e.target.value);
        await this.setState({ tol: e.target.value })
    }


    onFinish = async () => {
        console.log('finished!');
        await this.setState({ otpstate: true })
    }

    callOTP = async () => {
        try {
            const { client,citizenId,birthDate,empCode,organization } = this.props
            const { data, errors } = await client.query({
                query: Queries.sendVerifyCode,
                variables: {
                    requestFor: "FORGET_PASSWORD",
                    sendMethod: "SMS",
                    citizenId: citizenId,
                    birthDate: birthDate,
                    empCode: empCode,
                    organization: getOrganization(),
                    // organization: organization,
                }
            })
            console.log("data",data);
            
            await this.setState({
                otpstate: false,
                deadline: Date.now() + 1000 * (moment(data.sendVerifyCode.endTime).unix() - moment(data.sendVerifyCode.startTime).unix()),
                called: true,
                text: data.sendVerifyCode.text,
            })

        } catch (error) {
            console.log(error)
        }
    }

    componentDidMount = async () => {
        if (this.props.tel) {
            await this.setState({ tol: this.props.tel })
        }
    }

    render() {
        // console.log("Date.now()", Date.now());
        const { otpstate, called, tol, valueOTP } = this.state;
        const { tel, type } = this.props;
        return (
            <>
                {/* <Form.Item label={<b>รหัสยืนยัน OTP</b>} colon={false} name="verificationCode" >
                    {getFieldDecorator('verificationCode', {
                    rules: [{ required: true, message: 'กรุณาใส่รหัสยืนยัน' }]
                })
                ( */}
                <div className='mt-2 mb-1'>
                    <div className='mt-4 mb-3' style={{ width: "100%" }}>
                        <div className="mb-3">
                            {!tel &&
                                <>
                                    <Text className='color-red' >* </Text>
                                    <Text className='color-black' style={{ marginBottom: "10px" }}> เบอร์โทรศัพท์</Text>
                                </>
                            }
                            <Row gutter={[16, 16]}>
                                <Col span={14}>
                                    <Text className='color-black'>{this.state.text}</Text>
                                </Col>
                                <Col span={10}>
                                    <div style={{ textAlign: "center"}}>
                                        {otpstate &&
                                            <Button className='mr-1' type="primary btn-color-callOTP btn-custom" onClick={this.callOTP} style={{ width:"100%" }}>
                                                {type == "otp" &&
                                                    <Text className='color-black'>ขอรหัส OTP<br /></Text>
                                                    ||
                                                    <Text className='color-black'>ขอรหัสยืนยันตัวตน<br /></Text>
                                                }
                                            </Button>
                                            ||
                                            <Button disabled={true} className='mr-1' type="primary btn-color-disableOTP btn-custom" onClick={this.callOTP} style={{ width:"100%" }}>
                                                {type == "otp" &&
                                                    <Text className='color-black'>ขอรหัส OTP<br /></Text>
                                                    ||
                                                    <Text className='color-black'>ขอรหัสยืนยันตัวตน<br /></Text>
                                                }
                                            </Button>
                                        }
                                        {
                                            ( this.state.deadline && otpstate == false) &&
                                            <Row>
                                                <Col span={14} offset={3}>
                                                    <Text className='color-gray' style={{ fontSize: "10px" }}>สามารถกดขอใหม่ได้อีกครั้งใน :</Text>
                                                </Col>
                                                <Col span={4}>
                                                    <Countdown className="mt-1" valueStyle={{ fontSize: "10px" }} value={this.state.deadline} format="mm:ss" onFinish={this.onFinish} />
                                                </Col>
                                                <Col span={3}>
                                                    {/* <Countdown valueStyle={{ fontSize: "10px" }} value={this.state.deadline} format="mm:ss" /> */}
                                                </Col>
                                            </Row>
                                        }
                                       
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    {called &&
                        <>
                            <div className="mb-3">
                                <Text className='color-red' >* </Text>
                                {type == "otp" &&
                                    <Text className='color-black'>รหัส OTP<br /></Text>
                                    ||
                                    <Text className='color-black' style={{ marginBottom: "10px" }}>รหัสยืนยันตัวตนที่ได้จาก SMS</Text>
                                }
                            </div>
                            <Input.Password
                                value={valueOTP}
                                style={{ borderRadius: '100px' }}
                                type="verificationCode"
                                onChange={this.onChange}
                                placeholder=""
                                maxLength="6"
                            />
                        </>
                    }
                </div>
                {/* ) */}
                {/* } */}
                {/* </Form.Item> */}
            </>
        )
    }
}

OTPFrom.defaultProps = {
    disabled: false,
    loading: false
}

OTPFrom.propTypes = {
    onAdd: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool
}

export default withApollo(OTPFrom)
// const WrappedConfirmUser = Form.create()(OTPFrom)

// export default WrappedConfirmUser